// import types
import { DutyLineNote } from 'RestAPIs/employees/hours-table/types';
import { EmployeeNotesResponse } from 'RestAPIs/employees/notes';

export const isPrivateNote = (
  note: DutyLineNote | EmployeeNotesResponse
): boolean => {
  return note.flags.includes('PRIVATE');
};

export const isExternalNote = (
  note: DutyLineNote | EmployeeNotesResponse
): boolean => {
  return note.flags.includes('EXTERNAL');
};
